var map = {
	"./arg.svg": 938,
	"./aus.svg": 939,
	"./bel.svg": 940,
	"./bra.svg": 941,
	"./can.svg": 942,
	"./cmr.svg": 943,
	"./crc.svg": 944,
	"./cro.svg": 945,
	"./den.svg": 946,
	"./ecu.svg": 947,
	"./eng.svg": 948,
	"./esp.svg": 949,
	"./fra.svg": 950,
	"./ger.svg": 951,
	"./gha.svg": 952,
	"./irn.svg": 953,
	"./jpn.svg": 954,
	"./kor.svg": 955,
	"./ksa.svg": 956,
	"./mar.svg": 957,
	"./mex.svg": 958,
	"./ned.svg": 959,
	"./pol.svg": 960,
	"./por.svg": 961,
	"./qat.svg": 962,
	"./sen.svg": 963,
	"./srb.svg": 964,
	"./sui.svg": 965,
	"./tun.svg": 966,
	"./uru.svg": 967,
	"./usa.svg": 968,
	"./wal.svg": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2504;